export default "__VITE_ASSET__MUho6BeP__"